(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsSearchFieldNames(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsSearchFieldNames(
            RivalIQ.enums
        );
    }

    function enumsSearchFieldNames(exports) {

        exports.searchFieldNames = {
            searchTerm: {
                fieldName: 'searchTerm',
                name: 'Post Content'
            },
            canonicalUrlFilter: {
                fieldName: 'canonicalUrlFilter',
                name: 'URL'
            },
            primaryDomainFilter: {
                fieldName: 'primaryDomainFilter',
                name: 'Domains'
            }
        };
    }
})();
